import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

export const AccountContext = createContext();

export const AccountProvider = ({ children }) => {
  const { user } = useAuth();
  // Key by user id so different logins never share the same stored selection
  const storageKey = user?.id ? `selectedAccount_${user.id}` : null;

  const [selectedAccount, setSelectedAccount] = useState("");
  // True once the persisted selection has actually been restored from
  // localStorage for the logged-in user. Consumers that decide whether the
  // current selection is "valid" (e.g. UserBox resetting to a default when
  // the account list loads) must wait for this — otherwise they can run
  // before storageKey is ready (user not loaded yet), see selectedAccount
  // still at its initial "", and wrongly stomp a real persisted account
  // with a default (confirmed live: reset to "All Accounts" on fresh loads).
  const [accountHydrated, setAccountHydrated] = useState(false);

  // Re-read from localStorage whenever the logged-in user changes
  useEffect(() => {
    if (!storageKey) return;
    const stored = localStorage.getItem(storageKey) || "";
    setSelectedAccount(stored);
    setAccountHydrated(true);
  }, [storageKey]);

  // Persist whenever selection changes
  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(storageKey, selectedAccount);
    }
  }, [selectedAccount, storageKey]);

  return (
    <AccountContext.Provider value={{ selectedAccount, setSelectedAccount, accountHydrated }}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => useContext(AccountContext);
